import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    if (navigationType === 'POP' || hash) {
      return
    }

    const instant = { top: 0, left: 0, behavior: 'instant' as ScrollBehavior }
    window.scrollTo(instant)
    document.querySelector('.ph-main')?.scrollTo(instant)
  }, [pathname, hash, navigationType])

  return null
}
